module.exports = __webpack_public_path__ + "img/CECA_CD8T.dcacfd1c.png";